// extracted by mini-css-extract-plugin
module.exports = {"Arrows":"Arrows_Arrows__A0DzI","Icon":"Arrows_Icon__2c0Gc"};